<template>
  <div class="steps-section">
    <h2>Votre transformation, étape par étape : </h2>
    <StepItem v-for="(step, index) in steps" :key="index" :number="step.number" :title="step.title" :gain="step.gain" />
    <div class="btn-wrapper">
      <ButtonLink class="text-center" title="Commencer ma transformation" :to="{ path: '/a-propos', hash: '#contact-form' }" />
    </div>
  </div>
</template>

<script>
  import StepItem from "./StepItem.vue";
  import ButtonLink from "./ButtonLink.vue";

  export default {
    name: "StepsSection",
    components: {
      StepItem,
      ButtonLink
    },
    data() {
      return {
        steps: [{
            number: "01",
            title: "Comprendre vos schémas",
            gain: "Anticipez vos réactions, reprenez la main sur vos automatismes.",
          },
          {
            number: "02",
            title: "Maîtriser votre langage intérieur",
            gain: "Apprenez à décoder les signaux subtils du corps, des émotions et du mental.",
          },
          {
            number: "03",
            title: "Appliquer des outils concrets",
            gain: "Intégrez des micro-ajustements au quotidien (issus de notre méthode exclusive).",
          },
          {
            number: "04",
            title: "Déployer un leadership aligné",
            gain: "Dirigez avec ancrage, justesse et impact.",
          },
          {
            number: "05",
            title: "Intégrer une pratique durable",
            gain: "Naviguez avec fluidité dans les hauts et les bas.",
          },
        ],
      };
    },
  };
</script>

<style lang="scss" scoped>
  .steps-section {
    padding: 2rem;
    max-width: 800px;
    margin: 0 auto;


    li {
      list-style: none !important;
    }

    .btn-wrapper {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }

  }
</style>